// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CyHw","colBig":"styles_colBig__3Nt0F","colSmall":"styles_colSmall__fw9rk"};